export enum DestinationTypes {
  country = "country",
  region = "region",
  postcode = "postcode",
  district = "district",
  place = "place",
  locality = "locality",
  city = "city",
  neighborhood = "neighborhood",
  street = "street",
  address = "address",
  poi = "poi",
  category = "category",
}
